import { use } from "react";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { AuthUIContext } from "@papier/auth-ui";
import { authClient } from "@/lib/auth-client";
import { orpc } from "@/lib/orpc";
import { useSearchFilters } from "@/hooks/use-search-filters";
import { SendingWorkspace } from "@/components/sending/sending-workspace";
import { sendingSearch } from "@/components/sending/sending-search";
import { getDefaultEnvironment } from "@/components/project/environment-search";

export const Route = createFileRoute("/_app/projects/$projectSlug/_layout/sending")({
  component: SendingPage,
  validateSearch: sendingSearch,
  beforeLoad: async ({ context: { queryClient, orpc }, params, search }) => {
    if (search.env && search.env !== "all") return;
    const project = await queryClient.ensureQueryData(
      orpc.projects.getBySlug.queryOptions({ input: params }),
    );
    const environment = getDefaultEnvironment(project.environments);
    if (environment) {
      throw redirect({
        to: "/projects/$projectSlug/sending",
        params,
        search: { ...search, env: environment.slug },
        replace: true,
      });
    }
  },
  head: () => ({ meta: [{ title: "Papier - Sending" }] }),
});

function SendingPage() {
  const params = Route.useParams();
  const { filters, setFilters } = useSearchFilters(Route.id);
  const { data: project } = useSuspenseQuery(
    orpc.projects.getBySlug.queryOptions({ input: params }),
  );
  const {
    hooks: { useHasPermission },
  } = use(AuthUIContext);
  const { data: organization } = authClient.useActiveOrganization();
  const { data: permission } = useHasPermission({
    organizationId: organization?.id,
    permissions: { organization: ["update"] },
  });
  return (
    <SendingWorkspace
      key={`${organization?.id}-${project.id}`}
      project={project}
      search={filters}
      onSearchChange={setFilters}
      canManage={permission?.success === true}
    />
  );
}
